module.exports = {
  "version": "0.27.2"
};


//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/env/data.js
// module id = 221
// module chunks = 20